import moment from 'moment/moment'

// Single source of truth for usage on/off datetime parsing and "is it running"
// decisions. Replaces ad-hoc `new Date('YYYY-MM-DD HH:mm')` constructions that
// diverged across components (space vs T separators, 12h tokens, NaN handling).

const DATE_TIME_FORMATS = [
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD H:mm:ss',
  'YYYY-MM-DD H:mm',
  'YYYY-MM-DD'
]

export const parseUsageDateTime = (date, time, fallbackTime) => {
  if (!date) {
    return null
  }
  const timePart = time || fallbackTime
  const value = timePart ? `${date} ${timePart}` : `${date}`
  const parsed = moment(value, DATE_TIME_FORMATS, true)
  return parsed.isValid() ? parsed.toDate() : null
}

export const usageOnAt = usage =>
  parseUsageDateTime(usage.on_date, usage.on_time, '00:00:00')

export const usageOffAt = usage =>
  usage.off_date ? parseUsageDateTime(usage.off_date, usage.off_time, '23:59:59') : null

// Running = verifiably started and not verifiably stopped.
// An unparseable on treats the usage as not running (can't confirm it started).
// An off_date that is present but unparseable treats the usage as CLOSED —
// the old NaN-counts-as-running behavior produced false "already running" blocks.
export const isUsageRunningAt = (usage, at = new Date()) => {
  if (!usage) {
    return false
  }
  const on = usageOnAt(usage)
  if (!on || on > at) {
    return false
  }
  if (!usage.off_date) {
    return true
  }
  const off = usageOffAt(usage)
  if (!off) {
    return false
  }
  return off >= at
}

export const relationId = value =>
  value && typeof value === 'object' ? value.id : value
